<template>
    <div class="brief">
        <div class="row">
            <!-- 左边 -->
            <div class="fl w235">
                <div class="sideTitle2">
                    <div class="list-img">
                        <h5>产品技术服务</h5>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in list" :class="isActive == index?'active': ''" :key="index"
                                @click="listClick(item.id,index)">
                                <p>{{item.text}}</p>
                                <i class="el-icon-arrow-right"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sideImg">
                    <img src="../../../assets/image/mxu.jpg" alt="">
                </div>
            </div>
            <!-- 右边 -->
            <div class="fr w750">
                <div class="pageBox2">
                    <div class="about">
                        <!-- 公司信息部分 -->
                        <div class="company-info">
                            <h3>公司信息</h3>
                            <el-divider></el-divider>
                            <div class="info-item">
                                
                                <span class="value" style="font-size: 40px; color: #5082ab; font-weight: bold;">{{companyInfo.unitName}}</span>
                            </div>
                            <el-divider></el-divider>
                            <div class="info-item">
                                <span class="label">官网地址：</span>
                                <a :href="companyInfo.website" target="_blank" class="value link">{{companyInfo.website}}</a>
                            </div>
                            <div class="info-item">
                                <span class="label">联系人：</span>
                                <span class="value">{{companyInfo.contacts}}</span>
                            </div>
                            <div class="info-item">
                                <span class="label">联系方式：</span>
                                <span class="value">{{companyInfo.contactsPhone}}</span>
                            </div>
                            <div class="info-item description">
                                <span class="label">公司简介：</span>
                                <p class="value">{{companyInfo.unitDescreation}}</p>
                            </div>
                        </div>
                        
                        <!-- 产品列表部分 -->
                        <div class="product-list">
                            <h3>产品列表</h3>
                            <el-divider></el-divider>
                            <div v-for="(product, index) in productList" :key="index" class="product-item">
                                <div class="product-image">
                                    <img :src="product.enclosure" alt="产品图片">
                                </div>
                                <div class="product-details">
                                    <h4>{{product.productName}}</h4>
                                    <el-divider></el-divider>
                                    <div class="detail-item">
                                        <span class="label">产品类别：</span>
                                        <span class="value">{{product.productType}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="label">产品分类：</span>
                                        <span class="value">{{product.categorize}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="label">规格：</span>
                                        <span class="value">{{product.size}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="label">主要有效成分：</span>
                                        <span class="value">{{product.factor}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="label">适用范围：</span>
                                        <span class="value">{{product.scope}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <span class="label">产品型号：</span>
                                        <span class="value">{{product.product_sn}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- 分页 -->
                        <div class="pages">
                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" small
                                layout="prev, pager, next" :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                companyInfo: {},
                productList: [],
                total: 0,
                isActive: 0,
                companyName: this.$route.query.companyName,
                productId: this.$route.params.productId,
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    unitName: ''
                },
                list: [{
                        text: '产品公司列表',
                        id: 1
                    },
                    {
                        text: '产品列表',
                        id: 2
                    }
                ]
            }
        },
        mounted() {
            this.getProductList();
        },
        methods: {
            // 获取产品列表数据
            getProductList() {
                if (this.productId) {
                    this.$axios.get(`/business/productDetail/${this.productId}`).then(res => {
                        if (res.data) {
                            console.log(res.data);
                            this.setupPage(res.data);
                        }
                    });
                } else {
                    this.queryParams.unitName = this.companyName;
                    this.$axios.post('/business/productListByCompany', {
                        params: {
                            ...this.queryParams
                        }
                    }).then(res => {
                        if (res.data.rows && res.data.rows.length > 0) {
                            this.setupPage(res.data.rows);
                        }
                    });
                }
            },
            setupPage(data) {
                if(this.productId){
                    if(data){
                        const productinfo=data.data;
                        this.companyInfo = {
                            unitName: productinfo.unitName || this.companyName,
                            website: productinfo.website || '',
                        };
                        let imageUrl = '';
                        if (productinfo.enclosure) {
                            try {
                                const enclosureArray = JSON.parse(productinfo.enclosure);
                                if (Array.isArray(enclosureArray) && enclosureArray.length > 0 && enclosureArray[0].url) {
                                    imageUrl = enclosureArray[0].url;
                                }
                            } catch (e) {
                                imageUrl = productinfo.enclosure;
                            }
                        }
                        productinfo.enclosure = imageUrl;
                        this.productList = [productinfo];
                        this.total = 1;
                    }
                }else{
const products = Array.isArray(data) ? data : [data];
                
                if (products.length > 0) {
                    const firstProduct = products[0];
                    this.companyInfo = {
                        unitName: firstProduct.unitName || this.companyName,
                        website: firstProduct.website || '',
                        unitDescreation: firstProduct.unitDescreation || '',
                        contacts: firstProduct.contacts || '',
                        contactsPhone: firstProduct.contactsPhone || ''
                    };

                    this.productList = products.map(p => {
                        let imageUrl = '';
                        if (p.enclosure) {
                            try {
                                const enclosureArray = JSON.parse(p.enclosure);
                                if (Array.isArray(enclosureArray) && enclosureArray.length > 0 && enclosureArray[0].url) {
                                    imageUrl = enclosureArray[0].url;
                                }
                            } catch (e) {
                                imageUrl = p.enclosure;
                            }
                        }
                        p.enclosure = imageUrl;
                        return p;
                    });
                    this.total = Array.isArray(data) ? data.length : 1;
                }
                }
                
            },
            handleSizeChange(row) {
                this.queryParams.pageSize = row;
                this.getProductList();
            },
            handleCurrentChange(row) {
                this.queryParams.pageNum = row;
                this.getProductList();
            },
            listClick(id, index) {
                this.isActive = index;
                if (id == 1) {
                    this.$router.push({
                        path: '/companyList',
                    });
                } else if (id == 2) {
                    this.$router.push({
                        path: '/productList',
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .brief {
        margin: 20px 0;
        overflow: hidden;

        .row {
            width: 1000px;
            background-color: #FFF;
            margin: 0 auto;

            .w235 {
                width: 235px;
                left: -8px;

                .sideImg {
                    text-align: center;
                    padding: 20px 0;
                }
            }

            .w750 {
                width: 750px;
                position: relative;
                right: -7px;

                .pageBox2 {
                    min-height: 830px;
                    border: 1px #DDDDDD solid;
                    border-radius: 5px;
                    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
                        0 0 6px 0 rgba(0, 0, 0, 0.04);

                    .about {
                        padding: 45px 35px;
                        line-height: 20px;
                        text-align: justify;

                        h3 {
                            font-size: 18px;
                            color: #066FC4;
                            margin-bottom: 10px;
                        }

                        .company-info {
                            margin-bottom: 30px;
                            
                            .info-item {
                                margin: 10px 0;
                                display: flex;
                                
                                .label {
                                    font-weight: bold;
                                    width: 100px;
                                }
                                
                                .value {
                                    flex: 1;
                                }
                                
                                .link {
                                    color: #066FC4;
                                    text-decoration: underline;
                                }
                            }
                            
                            .description {
                                display: block;
                                
                                .label {
                                    display: block;
                                    margin-bottom: 5px;
                                }
                                
                                .value {
                                    line-height: 1.6;
                                }
                            }
                        }
                        
                        .product-list {
                            .product-item {
                                display: flex;
                                margin-bottom: 30px;
                                padding-bottom: 20px;
                                border-bottom: 1px dashed #ddd;
                                
                                .product-image {
                                    width: 200px;
                                    height: 200px;
                                    overflow: hidden;
                                    margin-right: 20px;
                                    
                                    img {
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    }
                                }
                                
                                .product-details {
                                    flex: 1;
                                    
                                    h4 {
                                        font-size: 30px;
                                        color: #5082ab;
                                        margin-bottom: 10px;
                                    }
                                    
                                    .detail-item {
                                        margin: 5px 0;
                                        
                                        .label {
                                            font-weight: bold;
                                            margin-right: 5px;
                                        }
                                    }
                                }
                            }
                        }

                        .pages {
                            padding: 20px 0;
                            display: flex;
                            justify-content: center;
                        }
                    }
                }
            }
        }
    }
</style>